import axios from 'axios';

import { BASE_URL, WEB_CATALOG } from '../constants/baseUrl';

axios.defaults.timeout = 5 * 60 * 1000;

export function setBaseUrl(base = BASE_URL) {
    axios.defaults.baseURL = base;
}

export function setWebCatalog(webCatalog = WEB_CATALOG) {
    if (webCatalog) {
        axios.defaults.headers.common['Web-Catalog'] = webCatalog;
    }
}
